import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { useId } from '../../../internal/hooks';
import { useDeviceType } from '../../../responsive';
import { generateDataTestId } from '../../../internal/utils';
import { Radio } from '../Radio';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
function RadioGroupComponent(props) {
  const {
    options,
    value,
    defaultValue,
    disabled,
    invalid,
    onChange,
    horizontal,
    role,
    dataTestId
  } = props;
  const deviceType = useDeviceType();
  const styles = getStyles(deviceType);
  const isControlled = React.useRef(props.hasOwnProperty('value'));
  const preparedOptions = React.useMemo(() => {
    return options.map(option => _objectSpread(_objectSpread({}, option), {}, {
      onChange: onChange && (e => onChange(e, option.value))
    }));
  }, [options, onChange]);
  const name = useId(props.name);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['radio-group'], horizontal ? styles['horizontal-group'] : styles['vertical-group']),
    role: role,
    children: preparedOptions.map(option => {
      const key = String(option.value);
      return /*#__PURE__*/_jsx(Radio, {
        // Приводится к строке, чтобы не ослаблять типы
        name: name,
        value: key,
        checked: isControlled.current ? value === option.value : undefined,
        defaultChecked: defaultValue !== undefined ? defaultValue === option.value : undefined,
        disabled: disabled,
        invalid: invalid,
        label: option.label,
        onChange: option.onChange,
        role: role === 'listbox' ? 'option' : undefined,
        dataTestId: generateDataTestId(dataTestId, [key])
      }, key);
    })
  });
}

/**
 * Компонент для работы с Radio как с группой
 *
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=33830-23114&node-type=canvas&t=dWJSsCGr4smKrzpW-0)
 *
 * @export
 * @param {IRadioGroupProps} props
 * @returns
 */
export const RadioGroup = /*#__PURE__*/React.memo(RadioGroupComponent);